import React from "react";
import { Reveal, Label } from "./anim";
import { Headshot } from "./Headshot";
import { PROFILE } from "../data/content";
import { MapPin } from "lucide-react";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative bg-[#EFEBDE] py-24 md:py-40">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 grid lg:grid-cols-[0.85fr_1.15fr] gap-12 lg:gap-20 items-start">
        <Reveal>
          <div className="relative">
            <Headshot className="w-full aspect-[4/5]" testid="about-headshot" />
            <div className="absolute -bottom-5 -right-3 md:-right-5 bg-[#2C5F3A] text-[#EFEBDE] px-5 py-4 shadow-lg">
              <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#EFEBDE]/70">Based in</p>
              <p className="font-display font-semibold text-lg tracking-tight flex items-center gap-2">
                <MapPin size={15} /> {PROFILE.location}
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <Label>About</Label>
          <h2 className="mt-6 font-display font-semibold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] text-[#16281C]">
            Building approvals, <span className="text-[#2C5F3A]">responsibly.</span>
          </h2>
          <div className="mt-8 space-y-6 font-body text-base md:text-lg text-[#4C5C50] leading-relaxed max-w-2xl">
            <p>
              I'm a pre-development and commercial permitting leader with 10+ years navigating the full approval lifecycle for projects valued from $100K to $100M+ across all 50 states — from ground-up construction and tenant improvements to data centers, warehouse fulfillment, retail, and hospitality.
            </p>
            <p>
              My background is unusual: I've worked <span className="text-[#16281C] font-medium">both sides of the counter</span>, as a Plans Examiner inside municipal building departments, and as the person navigating those same departments for national developers and brands. That dual perspective means fewer surprises, fewer resubmittals, and faster approvals.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
